import { InputTheme } from '../../base/tokens'

export const input: InputTheme = {
  base: 'w-full bg-gray-900/50 border border-cyan-500/20 rounded-lg px-4 py-2.5 text-cyan-100/90 text-sm transition-colors placeholder:text-cyan-100/30',
  focus: 'focus:border-cyan-400/30 focus:outline-none focus:ring-1 focus:ring-cyan-400/20',
  error: 'border-red-400/30 focus:border-red-400/40 focus:ring-red-400/20',
  placeholder: 'placeholder:text-cyan-100/30',
  states: {
    focus: 'focus:outline-none focus:ring-1 focus:ring-cyan-500/20 focus:border-cyan-500/40',
    disabled: 'opacity-50 cursor-not-allowed',
    active: 'border border-orange-500/70 ring-1 ring-orange-500/40 shadow-[0_0_15px_rgba(249,115,22,0.15)] transition-all duration-300 ease-in-out',
    next: 'border-orange-500/30 shadow-[0_0_8px_rgba(249,115,22,0.08)] transition-all duration-300 ease-in-out'
  },
  variants: {
    upload: {
      group: 'space-y-2',
      label: 'block text-sm font-medium text-cyan-100/90',
      input: 'w-full px-4 py-2.5 bg-gray-900/50 border border-cyan-500/20 rounded-lg text-cyan-100',
      button: 'bg-cyan-500/20 text-cyan-100/90 hover:bg-cyan-500/30',
      error: {
        wrapper: 'mt-2 p-3 bg-red-500/10 border border-red-500/20 rounded-lg',
        list: 'mt-2 space-y-1',
        message: 'text-sm text-red-400'
      }
    },
    form: {
      group: 'space-y-2',
      wrapper: 'relative',
      label: {
        base: 'block text-sm font-medium text-cyan-100/90',
        disabled: 'text-cyan-100/50',
        optional: 'ml-1 text-xs text-cyan-400/50',
        required: 'after:content-["*"] after:ml-1 after:text-red-400'
      },
      input: 'w-full px-4 py-2.5 bg-gray-900/50 border border-cyan-500/20 rounded-lg text-cyan-100 placeholder-cyan-100/30',
      error: {
        wrapper: 'mt-1',
        message: 'text-sm text-red-400'
      }
    },
    select: {
      group: 'space-y-2',
      label: {
        base: 'block text-sm font-medium text-cyan-100/90',
        disabled: 'text-cyan-100/50'
      },
      input: 'w-full px-4 py-2.5 bg-gray-900/50 border border-cyan-500/20 rounded-lg text-cyan-100 placeholder-cyan-100/30 transition-colors duration-200',
      option: 'bg-gray-900 text-cyan-100',
      description: 'block mt-2 text-sm text-cyan-100/70'
    },
    customSelect: {
      group: 'space-y-2',
      wrapper: 'relative',
      button: {
        base: 'w-full bg-gray-900/50 border border-cyan-500/20 rounded-lg px-4 py-2.5',
        label: 'block text-sm font-medium text-cyan-100/90',
        content: 'flex items-center justify-between',
        text: 'block truncate text-cyan-100/70',
        icon: {
          wrapper: 'flex items-center',
          background: 'bg-cyan-500/10 rounded-full p-1',
          svg: 'w-5 h-5 text-cyan-400/70'
        }
      },
      options: {
        wrapper: 'absolute mt-1 w-full bg-gray-900/95 border border-cyan-500/20 shadow-lg max-h-60 rounded-lg py-1 text-base overflow-auto focus:outline-none sm:text-sm',
        item: {
          base: 'cursor-default select-none relative py-2 pl-3 pr-9',
          active: 'text-cyan-300 bg-cyan-500/10',
          selected: 'font-medium',
          content: 'flex items-center',
          text: 'block truncate',
          textSelected: 'font-medium text-cyan-300',
          textUnselected: 'text-cyan-100/70'
        },
        checkbox: {
          base: 'w-4 h-4 border border-cyan-500/20 rounded',
          selected: 'bg-cyan-400 border-cyan-400',
          unselected: 'bg-gray-900/50',
          icon: 'w-3 h-3 text-white'
        }
      }
    },
    dropdown: {
      group: 'space-y-2',
      label: {
        base: 'block text-sm text-cyan-100/70',
        disabled: 'text-cyan-100/30'
      },
      button: {
        base: 'w-full bg-gray-900/50 border border-cyan-500/20 rounded-lg px-4 py-2.5',
        text: 'text-cyan-100/70',
        icon: {
          wrapper: 'flex items-center',
          background: 'bg-cyan-500/10 rounded-full p-1',
          svg: 'w-5 h-5 text-cyan-400/70'
        }
      },
      options: {
        wrapper: 'absolute mt-1 w-full bg-gray-900/95 border border-cyan-500/20 shadow-lg max-h-60 rounded-lg py-1 text-base overflow-auto focus:outline-none sm:text-sm',
        item: {
          base: 'cursor-default select-none relative py-2 pl-3 pr-9',
          active: 'text-cyan-300 bg-cyan-500/10',
          selected: 'font-medium',
          content: 'flex items-center',
          text: 'block truncate',
          textSelected: 'font-medium text-cyan-300',
          textUnselected: 'text-cyan-100/70'
        },
        checkbox: {
          base: 'w-4 h-4 border border-cyan-500/20 rounded',
          selected: 'bg-cyan-400 border-cyan-400',
          unselected: 'bg-gray-900/50',
          icon: 'w-3 h-3 text-white'
        }
      }
    }
  }
} 